import {
  createFileRoute,
} from '@tanstack/react-router'

import {
  AddPayeePage,
} from '@/features/payee/pages/add-payee-page'

export const Route = createFileRoute(
  '/_authenticated/customers/$customerId/payee/new',
)({
  component: AddPayeePage,
})